import React, { useEffect } from "react";
import "./FAQ.css";
import Accordion from "react-bootstrap/Accordion";

import AOS from "aos";
import "aos/dist/aos.css";

export default function FAQ() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="main_FAQ" id="faq">
      <div className="container">
        <h3 className="faq ">
          Frequently Asked Questions
          <br />
        </h3>
        <br></br>
        <p className="text-center text-black" style={{ fontSize: "20px" }}>
          You may have questions, we have the answers.
        </p>
        <div
          className="row justify-content-center mt-3"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <div className="col-md-8">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header> What is PIKU Coin?
                </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                  PIKU is the ultimate meme coin inspired by Pikachu, built to dominate the crypto space and end the reign of dog and cat meme coins.

                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2" className="mt-3">
                <Accordion.Header className="faq-head">
                  {" "}
                  What’s the total supply of PIKU?{" "}
                </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                  There’s a fixed supply of 1 billion PIKU, ensuring scarcity and value for holders.

                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3" className="mt-3">
                <Accordion.Header>
                  {" "}
                  How can I join the presale?
                </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                  Connect your wallet, select your BNB amount, and swap it for PIKU tokens. It’s that simple.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4" className="mt-3">
                <Accordion.Header>
                  {" "}
                  What utility does PIKU offer?
                  {" "}
                </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                  PIKU brings staking rewards, exclusive NFTs, and official merchandise while dominating the meme coin market.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5" className="mt-3">
                <Accordion.Header>
                  {" "}
                  When does PIKU launch on exchanges?

                </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                  After the presale, PIKU will debut on PancakeSwap, followed by listings on major exchanges.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}
